<template>
  <b-modal
    v-if="shouldShowOncePerSessionModal"
    id="once-per-session"
    ok-only
    @hide="handleHide"
    static
    size="sm"
  >
    <template v-slot:modal-title>
      <div v-html="modalData.displayName"></div>
    </template>

    <div v-html="modalData.body"></div>

  </b-modal>
</template>

<script>
export default {
  name: "ModalOncePerSession",
  data() {
    return {
    };
  },
  computed: {
    modalData(){
      return _.get(window, "heb.data.message.modalOncePerSession", false)
    },
    shouldShowOncePerSessionModal() {
      if (
        this.modalData && this.modalData.body
      ) {
        var displayName = this.modalData.displayName || false
        var modalId = "modal-once-per-session-" + displayName.replace(/;/g, "")

        if( document.cookie.indexOf(modalId) < 0) {
            document.cookie = modalId + "=shown" 
            return true
        }
      }
    }
  },
  mounted() {
    this.$bvModal.show('once-per-session')
  }
};
</script>

<style scoped></style>
